export const RandomId = () => {
    return Math.random().toString(36).slice(2);
};
